import "vanilla-cookieconsent/dist/cookieconsent.css";
import * as CookieConsent from "vanilla-cookieconsent";

document.addEventListener("DOMContentLoaded", function () {
    if(window.cookieconsent)
        CookieConsent.run(window.cookieconsent);
});
